const apiPaths = {
  status: '/users/:userId/timeline_status',
  defaultTimeline: '/users/:userId/timelines',
  timeline: '/users/:userId/timelines/:timelineId',
  periods: '/users/:userId/timelines/:timelineId/periods',
  period: '/users/:userId/timelines/:timelineId/periods/:periodId'
};

const PRIVACY_TO_MARS = {
  connections: 'family',
  private: 'private'
};

const PRIVACY_FROM_MARS = {
  family: 'connections',
  private: 'private'
};

function mapTimelineFromMars(timeline) {
  if (!timeline) return timeline;

  return {
    ...timeline,
    privacy: PRIVACY_FROM_MARS[timeline.privacy] || timeline.privacy
  };
}

export function useTimelineApi() {
  const api = useMarsApiV4();
  const statusApi = useMarsApiV3();

  return {
    async getStatus({userId}) {
      return await statusApi.fetch(apiPaths.status, {
        params: {route: {userId}}
      });
    },

    async getTimeline({userId, timelineId}) {
      const data = await api.fetch(
        timelineId ? apiPaths.timeline : apiPaths.defaultTimeline,
        {
          params: {
            route: {userId, timelineId}
          }
        }
      );
      return mapTimelineFromMars(data.timeline);
    },

    async updateTimeline({userId, timelineId, updates}) {
      const data = await api.fetch(apiPaths.timeline, {
        method: 'PATCH',
        params: {route: {userId, timelineId}},
        body: {
          timeline: {
            ...updates,
            ...(updates?.privacy
              ? {privacy: PRIVACY_TO_MARS[updates.privacy] || updates.privacy}
              : {})
          }
        }
      });
      return mapTimelineFromMars(data.timeline);
    },

    async getPeriods({userId, timelineId, type}) {
      const data = await api.fetch(apiPaths.periods, {
        params: {
          route: {userId, timelineId},
          query: {type}
        }
      });
      return data.periods.map(timelinePeriodMapper);
    },

    async getPeriod({userId, timelineId, periodId}) {
      const data = await api.fetch(apiPaths.period, {
        params: {route: {userId, timelineId, periodId}}
      });
      return timelinePeriodMapper(data.period);
    },

    async updatePeriod({userId, timelineId, periodId, updates}) {
      const data = await api.fetch(apiPaths.period, {
        method: 'PATCH',
        params: {route: {userId, timelineId, periodId}},
        body: {period: updates}
      });
      return timelinePeriodMapper(data.period);
    }
  };
}
